import { type Enum } from '@webapp/infrastructure/types/Enum'

/**
 * Steps of the two-step create wizard: collect values on `FORM`, then confirm
 * on `REVIEW`.
 */
export const CREATE_LEGAL_ENTITY_STEPS = {
  FORM: 'form',
  REVIEW: 'review',
} as const

export type CreateLegalEntityStep = Enum<typeof CREATE_LEGAL_ENTITY_STEPS>
